import React from 'react'
import { array } from 'prop-types'
import { connect } from 'react-redux'
import Category from './Category'
import { allCategory } from '../../../../config'

const filterCategories = categories => {
  let parkingCategory = categories.filter(
    category => category.description === 'parking'
  )
  let shownCategories = allCategory ? categories : parkingCategory
  return shownCategories
}

const CategoryList = ({ categories }) =>
  filterCategories(categories).map(category => (
    <Category key={category.id} category={category} categoryId={category.id} />
  ))

CategoryList.propTypes = {
  categories: array.isRequired,
}

const mapStateToProps = ({ spi }) => ({ categories: spi.categories })

export default connect(mapStateToProps)(CategoryList)



// WEBPACK FOOTER //
// ./src/components/Elements/Sidebar/Categories/CategoryList.jsx